import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { GSTFilingState } from 'src/app/modules/taxilla-library/lib/store/states';
import { Entity } from '../../models/entity.class';
import { getFilingSelectedAppMetaData$, getFilingSelectedInstanceDetails$ } from '../../store/selectors/gst-filing.selector';
import { SetFilingInstanceEntityView } from '../../store/actions/gst-filing.actions';

@Component({
    selector: 'app-instance-data-entities',
    templateUrl: './instance-data-entities.component.html',
    styleUrls: ['./instance-data-entities.component.scss'],
    standalone: false,
})
export class InstanceDataEntitiesComponent implements OnInit, OnDestroy {
    @Input() public entities: Entity[];
    @Input() public supportsRecon: boolean;
    @Input() public isCustomScreen = false;

    @Output() onEntitySelect = new EventEmitter<Entity>();

    public showBtnContent = 'Show More';
    private unsubscribe = new Subject();
    public selectedDetails: GSTFilingState['selected'];

    constructor(private store$: Store) {}

    public selectEntity = (entity: Entity, level: number) => {
        this.store$.dispatch(
            SetFilingInstanceEntityView({
                entityId: entity.uid,
                viewLevel: level,
                recordId: undefined,
            })
        );
        this.onEntitySelect.emit(entity);
    };

    ngOnInit() {
        !this.entities &&
            this.store$
                .select(getFilingSelectedAppMetaData$)
                .pipe(takeUntil(this.unsubscribe))
                .subscribe(event => {
                    this.entities = event?.entities || [];
                });
        this.store$
            .select(getFilingSelectedInstanceDetails$)
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(event => {
                this.selectedDetails = event;
            });
    }

    ngOnDestroy(): void {
        this.unsubscribe.next(undefined);
        this.unsubscribe.complete();
    }
}
